import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const MobileDeviceIphoneMonitor = (
  props: MyIconProps,
): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M16.752 19.7532H18.2526" />
      <path d="M8.99874 16.0017L8.49853 20.0033" />
      <path d="M20.0033 11.5608V5.42526C20.0033 4.08376 18.9158 2.99625 17.5743 2.99625H5.42526C4.08375 2.99625 2.99625 4.08376 2.99625 5.42526V13.5727C2.99625 14.9142 4.08375 16.0017 5.42526 16.0017H14.0008" />
      <path d="M6.99791 20.0033H14.0008" />
      <rect x="14.0008" y="11.4998" width="7.00292" height="10.5044" rx="1.5" />
    </svg>
  );
};
